export default "__VITE_ASSET__MEH82i6s__"